<script>
  import { onDestroy } from 'svelte';
  import { update_search } from "./Utils/RouterUtils.svelte";
  import { store } from "./Utils/stores.js";

  export let product = product;
  switch(product) {
  case "vcarve_pro":
  product = "VCarve Pro"
    break;
  case "vcarve_desktop":
  product = "VCarve Desktop"
    break;
  case "cut2d_pro":
  product = "Cut2D Pro"
    break;
  case "cut2d_desktop":
  product = "Cut2D Desktop"
    break;
  }

  let search_term = '';
  const unsubscribe = store.subscribe(value => {
    search_term = value.search || '';
  });
  onDestroy(unsubscribe);

  function handle_submit(evt) {
      update_search(search_term);
  }
  function getProductName() {
    if(product) {
      return product;
    }
    return "All"
  }
</script>

<div class="">
  <form
    on:submit|preventDefault={handle_submit}>
    <div class="vec-max-w-screen-md vec-mx-auto vec-flex vec-justify-content-center">
      <div class='md:vec-mx-auto vec-flex vec-justify-center vec-w-full vec-relative'>
        <input type="search" name="search" id="search"
          bind:value={search_term}
          class="vec-border vec-border-midGrey vec-rounded-md vec-rounded-bl-none vec-px-2 vec-w-full vec-h-12 vec-text-black focus:vec-ring-4 focus:vec-ring-black/10 vec-outline-none vec-capitalize" placeholder="Search {getProductName()} videos...">
        <button type="submit" class="vec-absolute vec-top-0 vec-right-0 vec-rounded-r-md vec-bg-white vec-h-12 vec-w-12 vec-flex vec-border vec-border-midGrey vec-border-l-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.973" viewBox="0 0 20 19.973" class="vec-m-auto">
            <path d="M25.343,16.888A8.122,8.122,0,0,1,23.539,22l5.481,5.481L27.8,28.7,22.33,23.218a8.161,8.161,0,1,1,3.013-6.33m-8.161-6.443a6.443,6.443,0,1,0,6.443,6.443,6.443,6.443,0,0,0-6.443-6.443" transform="translate(-9.02 -8.723)" fill-rule="evenodd" fill="#000"/>
          </svg>        
          <span class="sr-only">Search</span>
        </button>
      </div>
    </div>
  </form>
</div>
